import { Modal, ModalOverlay, ModalContent, Box, Divider } from '@chakra-ui/react'
import { useEffect } from 'react'
import AboutContent from '../../pages/user/Content/aboutContent'
import Questionnaire from '../../pages/user/Content/Questionnaire'

interface ExploreContentModalProps {
  isOpen: boolean
  onClose: () => void
  contentItem: any | null
}

const ExploreContentModal: React.FC<ExploreContentModalProps> = ({ isOpen, onClose, contentItem }) => {
  if (!contentItem) return null

  useEffect(() => {
    if (!contentItem) {
      onClose()
    }
  }, [contentItem, onClose])

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="xl" scrollBehavior="inside">
      <ModalOverlay />
      <ModalContent maxW="70vw" maxH="90vh" overflowY="auto" py={4}>
        <Box mb={6}>
          <AboutContent contentId={contentItem?.id} isModal={true} onClose={onClose} />
          <Divider />
          <Box px="32px" pt="24px">
            <Questionnaire isModal={true} modalId={contentItem?.id} onClose={onClose} />
          </Box>
        </Box>
      </ModalContent>
    </Modal>
  )
}

export default ExploreContentModal
